import { useSelector } from 'react-redux'
import { ApplicationState } from '../store'
import { useMsal } from '@azure/msal-react'
import { UserWithOrganizationResponseDTO } from '../generated/ApiClient'

export function useActiveUser(): UserWithOrganizationResponseDTO {
    const { instance } = useMsal()
    const localAccountId = instance.getActiveAccount()!.localAccountId
    const user = useSelector<ApplicationState, UserWithOrganizationResponseDTO>(state => { 
        return state.users!.byId[localAccountId]
    })
    return user
}
